module.exports = __webpack_public_path__ + "static/media/iuli-logo-new-app.ab2a07e6.svg";